import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { GlobalContext } from 'providers/GlobalProvider';
import TrainingNav from '../../components/BiteU/BiteUNav';
import { Grid } from '@mui/material';
import CourseInfo from 'components/BiteU/CourseInfo';
import CourseStatus from 'components/BiteU/CourseStatus';
import CourseExtras from 'components/BiteU/CourseExtras';
import BiteUAPI from 'api/BITEUAPI';
import { useSnackbar } from 'notistack';

const BITEUCourseInfo: React.FC = (props: any) => {
  const { cur_user } = useContext(GlobalContext);
  const [ cur_lesson, setCurLesson ] = useState<any>({});
  const [ activeProgress, setActiveProgress ] = useState<any>({});
  const [ comingSoon, setComingSoon ] = useState<boolean>(false);
  const [ course, setCourse ] = useState<{
    isLoaded: boolean;
    data: any;
    error: string | undefined;
  }>({ isLoaded: false, data: {}, error: undefined });
  const [ userStatus, setUserStatus ] = useState<{
    isLoaded: boolean;
    data: any;
    error: string | undefined;
  }>({ isLoaded: false, data: {}, error: undefined });

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  if (!props.location.state) {
    return <Redirect to='/' />;
  }
  const { course_id } = props.location.state;
  const { enqueueSnackbar } = useSnackbar();

  // Subscription State and Functions
  const [ userHasBiteU, setUserHasBiteU ] = useState(false);
  const [ activeSub, setActiveSub ] = useState(false);

  const checkForBiteU = () => {
    if (cur_user.selected_team?.attributes?.tier?.includes('enterprise')) {
      setUserHasBiteU(true);
    }
    if (cur_user.stripe_cus_info) {
      cur_user.stripe_cus_info.map((cus: any) => {
        if (cus.name === cur_user.selected_team.name) {
          cus.subscriptions.data.map((sub: any) => {
            if (sub.metadata.moduleName === 'BITE Enterprise') {
              setActiveSub(true);
            }
          });
        }
      });
    }
  };

  useEffect(() => {
    checkForBiteU();
  }, [ activeSub ]);

  const getInfo = async() => {
    // COURSE INFO
    const courseResp = await BiteUAPI.getCourse(course_id);
    if (courseResp?.success) {
      setCourse({ data: courseResp?.result, isLoaded: true, error: undefined });
    } else if (courseResp) {
      const error_msg = `Error retrieving course: ${courseResp?.result}`;
      enqueueSnackbar(error_msg, { variant: 'error' });
      setCourse({ data: {}, isLoaded: true, error: error_msg });
    }

    // USER INFO
    const userResp = await BiteUAPI.getUserTrainingStatus();
    if (userResp?.success) {
      setUserStatus({
        data: userResp?.result[0],
        isLoaded: true,
        error: undefined,
      });
    } else {
      const error_msg = `Error retrieving user training status: ${userResp?.result}`;
      enqueueSnackbar(error_msg, { variant: 'error' });
    }
  };

  const isCompleted = (name: string, arr: any) => {
    const completed = arr.filter((less: any) => {
      return less.name === name;
    });
    return completed.length > 0;
  };

  useEffect(() => {
    getInfo();
  }, []);

  useEffect(() => {
    if (
      Object.keys(userStatus.data).length &&
      Object.keys(course.data).length
    ) {
      const findProgress = userStatus.data.progress.filter((prog: any) => {
        return prog.course === course.data.name;
      });
      setActiveProgress(findProgress[0]);
      const arr = findProgress[0].currentProgress;
      let lesToUse = findProgress[0].currentProgress[0];
      for (let i = 0; i < arr.length; i++) {
        if (
          !isCompleted(arr[i].lesson.name, findProgress[0].completedLessons)
        ) {
          lesToUse = arr[i];
          break;
        }
      }
      setCurLesson(lesToUse);

      if (!course.data.lessons[0].vidLink) {
        setComingSoon(true);
      }
    }
  }, [ userStatus, course ]);

  if (
    !course.isLoaded ||
    !userStatus.isLoaded ||
    Object.keys(cur_lesson).length === 0 ||
    Object.keys(activeProgress).length === 0
  ) {
    return (
      <div className='spinner-spacer-bite-u'>
        <div className='loader'>Loading...</div>
      </div>
    );
  }

  return (
    <>
      <TrainingNav basePath='BITE U / ' curPath={course.data.name} />
      <section
        className='home-content-body Training-HeaderDown'
        style={{ minHeight: 0 }}
      >
        <div className='bite-u-page-spacer'></div>
        <div className='HomeDashboard-container'>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <CourseInfo
                cur_course={course.data}
                user_status={userStatus}
                activeProgress={activeProgress}
                cur_lesson={cur_lesson}
                comingSoon={comingSoon}
                userHasBiteU={userHasBiteU}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CourseStatus
                cur_course={course.data}
                user_status={userStatus}
                cur_lesson={cur_lesson}
                comingSoon={comingSoon}
                userHasBiteU={userHasBiteU}
              />
            </Grid>
            <Grid item xs={12}>
              <CourseExtras user_status={userStatus} />
            </Grid>
          </Grid>
        </div>
      </section>
    </>
  );
};

export default BITEUCourseInfo;
